module.exports = __webpack_public_path__ + "static/media/clean_status_fail.20c261c6.svg";